import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Configuração do Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDJSjQ5G21MrzUopJS3ZuH0F2UWmjPVSpU",
    authDomain: "ofertiz-afca8.firebaseapp.com",
    projectId: "ofertiz-afca8",
    storageBucket: "ofertiz-afca8.firebasestorage.app",
    messagingSenderId: "383660067936",
    appId: "1:383660067936:web:5c4fff0b38e91fe99b4705"
};

// Inicializa Firebase
let app;
let auth;
let googleProvider;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
} catch (error) {
    console.warn("Firebase não inicializado:", error);
}

export { auth, googleProvider };
